import { MobileTab } from "@/containers/Project/components";
import * as S from "@/containers/Project/components/styled";
import { GUTTER_SIZE } from "@/enums";
import {
  faBarcode,
  faImage,
  faMapPin,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "antd";
import { element, func, string } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";

const MobileTabsLayout = ({
  milestonesCard,
  projectLeadersCard,
  imagesCard,
  skuCard,
}) => {
  const intl = useIntl();

  const [currentTab, setCurrentTab] = useState();

  const handleTabChange = (e) => {
    setCurrentTab(e.key);
  };

  const tabs = [
    {
      key: "milestones",
      label: (
        <MobileTab
          title={intl.formatMessage({ id: "project.milestonesTitle" })}
          icon={<S.StyledIcon icon={faMapPin} />}
        />
      ),
      children: milestonesCard,
    },
    {
      key: "projectLeaders",
      label: (
        <MobileTab
          title={intl.formatMessage({
            id: "regionalProjectLeaderCard.title",
          })}
          icon={<S.StyledIcon icon={faUsers} />}
        />
      ),
      children: projectLeadersCard,
    },
    {
      key: "images",
      label: (
        <MobileTab
          title={intl.formatMessage({ id: "project.imagesTitle" })}
          icon={<S.StyledIcon icon={faImage} />}
        />
      ),
      children: imagesCard,
    },
    {
      key: "sku",
      label: (
        <MobileTab
          title={intl.formatMessage({ id: "project.mobileSkuTitle" })}
          icon={<S.StyledIcon icon={faBarcode} />}
        />
      ),
      children: skuCard,
    },
  ];

  return (
    <Row gutter={GUTTER_SIZE.large}>
      <Col flex={1}>
        <S.ResponsiveTabs
          data-test-id="project-tabs"
          activeKey={currentTab}
          defaultActiveKey={"milestones"}
          onChange={handleTabChange}
          items={tabs}
        />
      </Col>
    </Row>
  );
};

MobileTabsLayout.propTypes = {
  milestonesCard: element,
  projectLeadersCard: element,
  imagesCard: element,
  skuCard: element,
  onTabChange: func,
  activeTab: string,
};

export { MobileTabsLayout };
